<template>
  <base-section id="theme-features">
    <base-section-heading title="Démarrage de piscine">
      <ul>
        <p style="margin:0;">Facilitez le démarrage de votre piscine au printemps en suivant ces quelques conseils pratiques.</p>
      </ul>
    </base-section-heading>
    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="justify"
            horizontal
          >
            {{ feature.text }}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          color: 'primary',
          dark: true,
          title: 'Nettoyage',
          icon: 'mdi-check',
          text: 'Nettoyez d\'abord le fond de la piscine avec le balai et le filtre en position ' +
            '"égout". En procédant ainsi, vous éviterez l\'encrassement du filtre',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Contrôle',
          icon: 'mdi-check',
          text: 'Assurez-vous ensuite que votre filtre de piscine soit propre et que ' +
            'la circulation de l\'eau soit efficace. ' + 'Quand le chlore a commencé à agir, démarrez la filtration et faites fonctionner sans arrêt jusqu\'à ' +
            'ce que l\'eau soit claire. Procédez périodiquement au lavage de votre filtre (backwash), en suivant ' +
            'les recommandations de son fabricant',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Traitement',
          icon: 'mdi-check',
          text: 'Quelle que soit l\'apparence de votre eau, vous devez procéder à un traitement de chlore choc',
        },
        {
          color: 'primary',
          dark: true,
          title: 'L\'alcalinité',
          icon: 'mdi-check',
          text: 'Après 48h, vérifiez et ajustez l\'alcalinité et le pH. Les normes ' +
            'recommandées sont de 7,2 à 7,8 pour le pH et de 80 à 120 ppm pour l\'alcalinité',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Démarrer Crystalline H20',
          icon: 'mdi-check',
          text: 'Déterminer à l\'aide de l\'outil de calcul interactif la quantité de produit à utiliser selon la taille' +
            ' de votre piscine. Verser une dose de Crystalline H20 dans le skimmer et diluez une dose supplémentaire de' +
            ' Crystalline H20 dans l\'eau chaude que vous dispersez dans la piscine. Notez que ce n\'est qu\'au moment du' +
            ' démarrage et de la fermeture de la piscine que vous aurez à utiliser une double dose de produit',
        },
      ],
    }),
  }
</script>
